<template>
  <div class="community-page flex-col">
    <div class="community-page__content flex-col">
      <div class="community-masthead flex-col">
        <app-header
          class="community-navigation"
          title="聚星社区"
          :brand-icon="require('@/assets/pages/community/images/8b7ec67320a2b928c4398d68f04116fa.png')"
          :menu-icon="require('@/assets/pages/community/images/af99e807486f3ffefd2dd0da700b02b2.png')"
        />
      </div>
      <div class="community-hero flex-col">
        <span class="community-hero__title">聚星社区</span>
        <span class="community-hero__subtitle">以企业用人标准为锚点，搭建从校园到职场的最短路径</span>
        <button class="community-hero__cta flex-col" type="button" @click="openContact">
          <span class="community-hero__cta-label">加入聚星计划</span>
        </button>
      </div>
      <div class="community-vision flex-col">
        <div class="community-vision__heading flex-row">
          <div class="community-vision__heading-accent-start flex-col"></div>
          <span class="community-vision__heading-label">我们的愿景</span>
          <div class="community-vision__heading-accent-end flex-col"></div>
        </div>
        <div class="community-vision__tagline flex-row justify-between">
          <img
            class="community-vision__mark"
            referrerpolicy="no-referrer"
            src="@/assets/pages/community/images/7ee12b5293fd872c98a8269f9eadd46f.png"
          />
          <span class="community-vision__tagline-copy">聚星社区，链接每一颗星</span>
        </div>
        <div class="community-vision__student-promise-card flex-col"><span class="community-vision__student-promise">让每一个学生都能找到属于自己的方向</span></div>
        <div class="community-vision__employer-promise-card flex-col">
          <span class="community-vision__employer-promise">让每一家有责任心的企业都能遇见志同道合的人才</span>
        </div>
        <div class="community-vision__campus-promise-card flex-col"><span class="community-vision__campus-promise">让校园与职场之间，不再隔着一道看不见的墙</span></div>
      </div>
      <div class="community-why flex-col">
        <div class="community-why__heading flex-row">
          <div class="community-why__heading-accent-start flex-col"></div>
          <span class="community-why__heading-label">我们为什么做这件事</span>
          <div class="community-why__heading-accent-end flex-col"></div>
        </div>
        <div class="community-why__employer-tab flex-col"><span class="community-why__employer-tab-label">企业的困惑</span></div>
        <div class="community-employer-challenges flex-col">
          <div class="community-employer-challenges__hiring-heading flex-row justify-between">
            <img
              class="community-employer-challenges__hiring-icon"
              referrerpolicy="no-referrer"
              src="@/assets/pages/community/images/4aa315ff8334931bdef01275a90a98b8.png"
            />
            <span class="community-employer-challenges__hiring-title">招聘季来了</span>
          </div>
          <span class="community-employer-challenges__hiring-question">
            为什么合适的简历那么少？培养一个应届生需要投入
            <br />
            多少成本？
          </span>
          <div class="community-employer-challenges__divider flex-col"></div>
          <div class="community-employer-challenges__profile-heading flex-row justify-between">
            <img
              class="community-employer-challenges__profile-icon"
              referrerpolicy="no-referrer"
              src="@/assets/pages/community/images/22f2427d4a3e71efa1867545e302102e.png"
            />
            <span class="community-employer-challenges__profile-title">人才画像模糊</span>
          </div>
          <span class="community-employer-challenges__profile-question">
            企业真正需要什么样的人才？技术能力之外，什么特质
            <br />
            最重要？
          </span>
        </div>
        <div class="community-why__student-tab flex-col"><span class="community-why__student-tab-label">学生的迷茫</span></div>
        <div class="community-student-challenges flex-col">
          <div class="community-student-challenges__graduation-heading flex-row justify-between">
            <img
              class="community-student-challenges__graduation-icon"
              referrerpolicy="no-referrer"
              src="@/assets/pages/community/images/9063d4b1168d4721ad00cee5ff8946a7.png"
            />
            <span class="community-student-challenges__graduation-title">毕业季到了</span>
          </div>
          <span class="community-student-challenges__graduation-question">我真的准备好了吗？简历上该写什么？面试该如何表现？</span>
          <div class="community-student-challenges__divider flex-col"></div>
          <div class="community-student-challenges__direction-heading flex-row justify-between">
            <img
              class="community-student-challenges__direction-icon"
              referrerpolicy="no-referrer"
              src="@/assets/pages/community/images/6416ee99220323160243573684200fac.png"
            />
            <span class="community-student-challenges__direction-title">方向不清晰</span>
          </div>
          <span class="community-student-challenges__direction-question">企业到底需要什么样的人才？我的专业能做什么？</span>
        </div>
      </div>
      <div class="community-bridge flex-col">
        <div class="community-bridge__scenario flex-col">
          <span class="community-bridge__scenario-copy">
            设想一下，如果能提前把"企业的用人标准"
            <br />
            变成"学生的学习内容"...
          </span>
        </div>
        <div class="community-bridge__statement flex-col justify-between">
          <span class="community-bridge__lead-in">于是，我们决定做</span>
          <span class="community-bridge__mission">聚星社区——连接企业标准与学生成长的公益桥梁</span>
        </div>
        <div class="community-bridge__commitment flex-col"><span class="community-bridge__commitment-label">用公益的方式，让校企之间不再隔着一道墙</span></div>
      </div>
      <div class="community-solution flex-col">
        <div class="community-solution__heading flex-row justify-between">
          <div class="community-solution__heading-accent-start flex-col"></div>
          <span class="community-solution__heading-label">企业定向培养解决方案</span>
          <div class="community-solution__heading-accent-end flex-col"></div>
        </div>
        <div class="community-solution__employer-community-path flex-row">
          <div class="community-solution__employer-stage flex-col justify-between">
            <img
              class="community-solution__employer-icon"
              referrerpolicy="no-referrer"
              src="@/assets/pages/community/images/c6f12250d2f45547504aa8dde641a5ca.png"
            />
            <span class="community-solution__employer-stage-copy">1、企业提出用人标准</span>
          </div>
          <img
            class="community-solution__employer-community-arrow"
            referrerpolicy="no-referrer"
            src="@/assets/pages/community/images/57d12fadfdc6164be6b6be6a73837ac4.png"
          />
          <div class="community-solution__community-stage flex-col justify-between">
            <img
              class="community-solution__community-icon"
              referrerpolicy="no-referrer"
              src="@/assets/pages/community/images/6fa219f7ff3c8e05423c72d9f28438a1.png"
            />
            <span class="community-solution__community-stage-copy">2、社区转化培养路径</span>
          </div>
        </div>
        <img
          class="community-solution__process-connector"
          referrerpolicy="no-referrer"
          src="@/assets/pages/community/images/fca64ee419503329f0de75caa630e880.png"
        />
        <div class="community-solution__society-internship-path flex-row">
          <div class="community-solution__student-society-stage flex-col justify-between">
            <img
              class="community-solution__student-society-icon"
              referrerpolicy="no-referrer"
              src="@/assets/pages/community/images/03873ea0ff7e389946a4764c978db4c6.png"
            />
            <span class="community-solution__student-society-stage-copy">4、大学社团执行</span>
          </div>
          <img
            class="community-solution__society-internship-arrow"
            referrerpolicy="no-referrer"
            src="@/assets/pages/community/images/5126be3406578db1041251d034b110f7.png"
          />
          <div class="community-solution__internship-stage flex-col justify-between">
            <img
              class="community-solution__internship-icon"
              referrerpolicy="no-referrer"
              src="@/assets/pages/community/images/5631f7faf24151c7840226c3059d1a1b.png"
            />
            <span class="community-solution__internship-stage-copy">3、企业实习&nbsp;→&nbsp;Offer</span>
          </div>
        </div>
        <div class="community-stakeholder-list flex-col">
          <div
            class="community-stakeholder-card flex-col"
            :style="{ background: item.cardBackground }"
            v-for="(item, index) in stakeholderCards"
            :key="index"
          >
            <div class="community-stakeholder-card__heading flex-row justify-between">
              <img class="community-stakeholder-card__icon" referrerpolicy="no-referrer" :src="item.icon" />
              <span class="community-stakeholder-card__title" v-html="item.title"></span>
            </div>
            <div class="community-stakeholder-card__benefits flex-row">
              <div v-if="item.showsUniversityBenefits" class="community-stakeholder-card__university-benefits flex-row">
                <div class="community-stakeholder-card__university-benefits-layout flex-row justify-between">
                  <img
                    class="community-stakeholder-card__university-benefits-icon"
                    referrerpolicy="no-referrer"
                    src="@/assets/pages/community/images/5380d35ae698be695cdb976602c6b43c.png"
                  />
                  <span class="community-stakeholder-card__university-benefits-copy">
                    产教融合，赋能学生发展
                    <br />
                    丰富学生实践机会
                    <br />
                    与企业建立深度合作
                  </span>
                </div>
                <img
                  class="community-stakeholder-card__university-benefits-decoration"
                  referrerpolicy="no-referrer"
                  src="@/assets/pages/community/images/900d2abfd588d99cc88db78b1935c5a0.png"
                />
              </div>
              <div v-if="item.partnerBenefits" class="community-stakeholder-card__partner-benefits flex-row">
                <div class="community-stakeholder-card__partner-benefits-copy flex-row justify-between">
                  <img class="community-stakeholder-card__benefits-icon" referrerpolicy="no-referrer" :src="item.partnerBenefits.icon" />
                  <span class="community-stakeholder-card__benefits-copy" v-html="item.partnerBenefits.description"></span>
                </div>
                <img class="community-stakeholder-card__benefits-decoration" referrerpolicy="no-referrer" :src="item.partnerBenefits.decoration" />
              </div>
              <img class="community-stakeholder-card__footer-decoration" referrerpolicy="no-referrer" :src="item.footerDecoration" />
            </div>
          </div>
        </div>
      </div>
      <div class="community-growth flex-col">
        <div class="community-growth__heading flex-row justify-between">
          <div class="community-growth__heading-accent-start flex-col"></div>
          <span class="community-growth__heading-label">个性化成长社区</span>
          <div class="community-growth__heading-accent-end flex-col"></div>
        </div>
        <span class="community-growth__introduction">
          我们认为，大学生在成长路上需要的支持，
          <br />
          不应该被信息差所阻断。
          <br />
          聚星社区致力于为学生提供全方位的成长陪伴
        </span>
        <div class="community-growth__language-competition-row flex-row justify-between">
          <div class="community-growth__language-card flex-row">
            <div class="community-growth__language-feature flex-col justify-between">
              <img
                class="community-growth__language-icon"
                referrerpolicy="no-referrer"
                src="@/assets/pages/community/images/4e642b2fd57ea9cb288a5f2858a1c7d5.png"
              />
              <div class="community-growth__language-copy flex-col justify-between">
                <span class="community-growth__language-title">英语学习</span>
                <span class="community-growth__language-description">语言能力成为你的竞争优势</span>
              </div>
            </div>
          </div>
          <div class="community-growth__competition-card flex-row">
            <div class="community-growth__competition-feature flex-col justify-between">
              <img
                class="community-growth__competition-icon"
                referrerpolicy="no-referrer"
                src="@/assets/pages/community/images/9e2e538b4e0700ba261ba7d203a7d6d6.png"
              />
              <div class="community-growth__competition-copy flex-col justify-between">
                <span class="community-growth__competition-title">竞赛指导</span>
                <span class="community-growth__competition-description">在实战中锤炼专业能力</span>
              </div>
            </div>
          </div>
        </div>
        <div class="community-growth__graduate-pathways-row flex-row justify-between">
          <div class="community-growth__graduate-guidance-card flex-row">
            <div class="community-growth__graduate-guidance-feature flex-col justify-between">
              <img
                class="community-growth__graduate-guidance-icon"
                referrerpolicy="no-referrer"
                src="@/assets/pages/community/images/9b6d4628fa3aa2c0b49d64f8c7fc37ed.png"
              />
              <div class="community-growth__graduate-guidance-copy flex-col justify-between">
                <span class="community-growth__graduate-guidance-title">考研辅助</span>
                <span class="community-growth__graduate-guidance-description">找到最适合自己的升学路径</span>
              </div>
            </div>
          </div>
          <div class="community-growth__graduate-recommendation-card flex-row">
            <div class="community-growth__graduate-recommendation-feature flex-col justify-between">
              <img
                class="community-growth__graduate-recommendation-icon"
                referrerpolicy="no-referrer"
                src="@/assets/pages/community/images/6fe549ed8f05e3efb61b773fe5ab0b22.png"
              />
              <div class="community-growth__graduate-recommendation-copy flex-col justify-between">
                <span class="community-growth__graduate-recommendation-title">保研攻略</span>
                <span class="community-growth__graduate-recommendation-description">赢在每一个关键节点</span>
              </div>
            </div>
          </div>
        </div>
        <div class="community-growth__career-pathways-row flex-row justify-between">
          <div class="community-growth__civil-service-card flex-row">
            <div class="community-growth__civil-service-feature flex-col justify-between">
              <img
                class="community-growth__civil-service-icon"
                referrerpolicy="no-referrer"
                src="@/assets/pages/community/images/6aea587ad6d739154cc2ac32be8f1203.png"
              />
              <div class="community-growth__civil-service-copy flex-col justify-between">
                <span class="community-growth__civil-service-title">考公资料</span>
                <span class="community-growth__civil-service-description">为梦想争取公平的机会</span>
              </div>
            </div>
          </div>
          <div class="community-growth__internship-card flex-row">
            <div class="community-growth__internship-feature flex-col justify-between">
              <img
                class="community-growth__internship-icon"
                referrerpolicy="no-referrer"
                src="@/assets/pages/community/images/03f431d4b65477bbd6a28f8e4279cc7a.png"
              />
              <div class="community-growth__internship-copy flex-col justify-between">
                <span class="community-growth__internship-title">实习就业</span>
                <span class="community-growth__internship-description">让每一次尝试都更有价值</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="community-content-formats flex-col">
        <div class="community-content-formats__heading flex-row justify-between">
          <div class="community-content-formats__heading-accent-start flex-col"></div>
          <span class="community-content-formats__heading-label">社区内容形式</span>
          <div class="community-content-formats__heading-accent-end flex-col"></div>
        </div>
        <div class="community-content-formats__mentor-feature flex-row justify-between">
          <img
            class="community-content-formats__mentor-icon"
            referrerpolicy="no-referrer"
            src="@/assets/pages/community/images/d3af821dda0ad06824924d50d3445ced.png"
          />
          <div class="community-content-formats__mentor-copy flex-col justify-between">
            <span class="community-content-formats__mentor-title">高校优质导师咨询赋能</span>
            <span class="community-content-formats__mentor-description">
              高校导师入驻，涵盖科研、心理、辅
              <br />
              导员等多方向，免费咨询，答疑解惑，
              <br />
              帮助学生规避成长误区，少走弯路。
            </span>
          </div>
          <div class="community-content-formats__mentor-index flex-col"><span class="community-content-formats__mentor-order">1</span></div>
        </div>
        <div class="community-content-formats__peer-feature flex-row justify-between">
          <img
            class="community-content-formats__peer-icon"
            referrerpolicy="no-referrer"
            src="@/assets/pages/community/images/fb00614a5dc62bbd83a4098b326d7617.png"
          />
          <div class="community-content-formats__peer-copy flex-col justify-between">
            <span class="community-content-formats__peer-title">优秀学长学姐经验分享</span>
            <span class="community-content-formats__peer-description">
              保研学霸、竞赛获奖者、留学先行者，
              <br />
              分享学习、备考、申请干货，提供可
              <br />
              复制的成长路径，助你事半功倍。
            </span>
          </div>
          <div class="community-content-formats__peer-index flex-col"><span class="community-content-formats__peer-order">2</span></div>
        </div>
        <div class="community-content-formats__student-network-feature flex-row justify-between">
          <img
            class="community-content-formats__student-network-icon"
            referrerpolicy="no-referrer"
            src="@/assets/pages/community/images/eb9d19056ecf72a8bb16bf717bb820d9.png"
          />
          <div class="community-content-formats__student-network-copy flex-col justify-between">
            <span class="community-content-formats__student-network-title">全国优秀学子集结</span>
            <span class="community-content-formats__student-network-description">
              跨校交流，拓展人脉，相互激励，汇
              <br />
              聚优质社交资源，为升学就业夯实人
              <br />
              脉基础。
            </span>
          </div>
          <div class="community-content-formats__student-network-index flex-col"><span class="community-content-formats__student-network-order">3</span></div>
        </div>
        <div class="community-content-formats__salon-feature flex-row justify-between">
          <img
            class="community-content-formats__salon-icon"
            referrerpolicy="no-referrer"
            src="@/assets/pages/community/images/3d373f6848ea65ce1bc6f62716b95c33.png"
          />
          <div class="community-content-formats__salon-copy flex-col justify-between">
            <span class="community-content-formats__salon-title">定期主题沙龙分享</span>
            <span class="community-content-formats__salon-description">
              线上+线下结合，季度开展，覆盖大学
              <br />
              规划、技能提升、竞赛、升学等核心
              <br />
              话题，互动答疑，全面提升认知能力。
            </span>
          </div>
          <div class="community-content-formats__salon-index flex-col"><span class="community-content-formats__salon-order">4</span></div>
        </div>
        <div class="community-content-formats__offline-event-feature flex-row justify-between">
          <img
            class="community-content-formats__offline-event-icon"
            referrerpolicy="no-referrer"
            src="@/assets/pages/community/images/2c1b0e4c20fb64877cd58a61ed7d1cc6.png"
          />
          <div class="community-content-formats__offline-event-copy flex-col justify-between">
            <span class="community-content-formats__offline-event-title">不定期线下活动</span>
            <span class="community-content-formats__offline-event-description">
              交流会、营地培训、技能比拼、高校
              <br />
              参观、导师面对面……深化交流，提
              <br />
              升实践能力，拓展视野边界。
            </span>
          </div>
          <div class="community-content-formats__offline-event-index flex-col"><span class="community-content-formats__offline-event-order">5</span></div>
        </div>
        <div class="community-content-formats__knowledge-feature flex-row justify-between">
          <img
            class="community-content-formats__knowledge-icon"
            referrerpolicy="no-referrer"
            src="@/assets/pages/community/images/b419b740c8818ab4d7a74b4afc2cfca2.png"
          />
          <div class="community-content-formats__knowledge-copy flex-col justify-between">
            <span class="community-content-formats__knowledge-title">公益知识持续输出</span>
            <span class="community-content-formats__knowledge-description">
              免费推送涵盖办公技能、学涯规划、
              <br />
              英语备考、社团经验等内容，常态化
              <br />
              成长，零成本提升。
            </span>
          </div>
          <div class="community-content-formats__knowledge-index flex-col"><span class="community-content-formats__knowledge-order">6</span></div>
        </div>
      </div>
      <div class="community-foundation flex-col">
        <div class="community-foundation__heading flex-row">
          <div class="community-foundation__heading-accent-start flex-col"></div>
          <span class="community-foundation__heading-label">背后的力量</span>
          <div class="community-foundation__heading-accent-end flex-col"></div>
        </div>
        <span class="community-foundation__introduction">
          依托智谷工业智能版块和新工科教育版块
          <br />
          拓展企业资源和高校资源
        </span>
        <div class="community-industry-panel flex-col">
          <div class="community-industry-panel__header flex-row justify-between">
            <img
              class="community-industry-panel__brand-icon"
              referrerpolicy="no-referrer"
              src="@/assets/pages/community/images/f54a4ba985bc48362c4a096a41b5d678.png"
            />
            <div class="community-industry-panel__brand-copy flex-col justify-between">
              <span class="community-industry-panel__name">智谷-工业智能板块</span>
              <span class="community-industry-panel__tagline">筑牢科技硬核</span>
            </div>
          </div>
          <div class="community-industry-panel__scenarios-heading flex-row justify-between">
            <div class="community-industry-panel__scenarios-accent flex-col"></div>
            <span class="community-industry-panel__scenarios-heading-label">深耕三大核心场景</span>
          </div>
          <div class="community-industry-panel__scenario-list flex-row">
            <div class="community-industry-panel__pipeline-safety-scenario flex-col"><span class="community-industry-panel__pipeline-safety-label">管道安全</span></div>
            <div class="community-industry-panel__smart-mining-scenario flex-col"><span class="community-industry-panel__smart-mining-label">智慧矿山</span></div>
            <div class="community-industry-panel__advanced-manufacturing-scenario flex-col"><span class="community-industry-panel__advanced-manufacturing-label">高端制造业</span></div>
          </div>
          <div class="community-industry-panel__capabilities-heading flex-row justify-between">
            <div class="community-industry-panel__capability-accent flex-col"></div>
            <span class="community-industry-panel__capabilities-heading-label">核心能力</span>
          </div>
          <span class="community-industry-panel__capabilities-list">
            •&nbsp;多项关键技术国产化替代&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;•&nbsp;自研全栈智能解决方案&nbsp;
            <br />
            •&nbsp;多项发明专利
          </span>
          <div class="community-industry-panel__clients-heading flex-row justify-between">
            <div class="community-industry-panel__clients-accent flex-col"></div>
            <span class="community-industry-panel__clients-heading-label">服务客户</span>
          </div>
          <div class="community-industry-panel__client-logos flex-row">
            <div class="community-industry-panel__pipeline-client flex-col justify-between">
              <img
                class="community-industry-panel__pipeline-logo"
                referrerpolicy="no-referrer"
                src="@/assets/pages/community/images/c8bc423e7e83ccf7350fc1d501760bed.png"
              />
              <span class="community-industry-panel__pipeline-client-name">国家管网集团</span>
            </div>
            <div class="community-industry-panel__offshore-client flex-col justify-between">
              <img
                class="community-industry-panel__offshore-logo"
                referrerpolicy="no-referrer"
                src="@/assets/pages/community/images/cfdaf2734d1c75f4b11fbafcda8fa5c5.png"
              />
              <span class="community-industry-panel__offshore-client-name">中国海油</span>
            </div>
            <div class="community-industry-panel__aerospace-client flex-col justify-between">
              <img
                class="community-industry-panel__aerospace-logo"
                referrerpolicy="no-referrer"
                src="@/assets/pages/community/images/e26e47745052dad94e8402ad652d9b5a.png"
              />
              <span class="community-industry-panel__aerospace-client-name">航天三院</span>
            </div>
            <div class="community-industry-panel__petrochemical-client flex-col justify-between">
              <img
                class="community-industry-panel__petrochemical-logo"
                referrerpolicy="no-referrer"
                src="@/assets/pages/community/images/1e056d64bdd55447785f6c53397b25dc.png"
              />
              <span class="community-industry-panel__petrochemical-client-name">中国石化</span>
            </div>
            <div class="community-industry-panel__academy-client flex-col justify-between">
              <img
                class="community-industry-panel__academy-logo"
                referrerpolicy="no-referrer"
                src="@/assets/pages/community/images/ae791f4fcb368bc3a3189f726bb25739.png"
              />
              <span class="community-industry-panel__academy-client-name">中国科学院</span>
            </div>
          </div>
        </div>
        <div class="community-education-panel flex-col">
          <div class="community-education-panel__header flex-row justify-between">
            <img
              class="community-education-panel__brand-icon"
              referrerpolicy="no-referrer"
              src="@/assets/pages/community/images/abb3068e2ee9321f9a635dd40a341fd9.png"
            />
            <div class="community-education-panel__brand-copy flex-col justify-between">
              <span class="community-education-panel__name">智谷-新工科教育板块</span>
              <span class="community-education-panel__tagline">搭建高校育人桥梁</span>
            </div>
          </div>
          <div class="community-education-panel__advantages-heading flex-row justify-between">
            <div class="community-education-panel__advantage-accent flex-col"></div>
            <span class="community-education-panel__advantages-heading-label">核心优势</span>
          </div>
          <span class="community-education-panel__advantages-copy">
            以场景化教育深度融合产业资源，拓展高校合作网络；
            <br />
            以新工科赛事服务为桥梁，拓展学生资源；
          </span>
          <div class="community-education-panel__services-heading flex-row justify-between">
            <div class="community-education-panel__services-heading-accent flex-col"></div>
            <span class="community-education-panel__services-heading-label">服务内容</span>
          </div>
          <div class="community-education-panel__service-list flex-row justify-between">
            <span class="community-education-panel__teaching-laboratory-services">
              •&nbsp;场景化教学解决方案
              <br />
              •&nbsp;实验室共建
            </span>
            <span class="community-education-panel__competition-research-services">
              •&nbsp;新工科赛事支撑
              <br />
              •&nbsp;省部级重大科研专项承接
            </span>
          </div>
          <div class="community-education-panel__colleges-heading flex-row justify-between">
            <div class="community-education-panel__colleges-heading-accent flex-col"></div>
            <span class="community-education-panel__colleges-heading-label">合作高校</span>
          </div>
          <div class="community-education-panel__college-logos flex-row">
            <div class="community-education-panel__northeastern-university flex-col justify-between">
              <img
                class="community-education-panel__northeastern-university-logo"
                referrerpolicy="no-referrer"
                src="@/assets/pages/community/images/184906c02442491953a2d03d5ba7a254.png"
              />
              <span class="community-education-panel__northeastern-university-name">东北大学</span>
            </div>
            <div class="community-education-panel__dalian-university flex-col justify-between">
              <img
                class="community-education-panel__dalian-university-logo"
                referrerpolicy="no-referrer"
                src="@/assets/pages/community/images/53852996ef4f6d46552b008ad4746a5e.png"
              />
              <span class="community-education-panel__dalian-university-name">
                大连理工
                <br />
                大学
              </span>
            </div>
            <div class="community-education-panel__partner-college-list flex-row">
              <div class="community-education-panel__partner-college flex-col justify-between" v-for="(item, index) in partnerColleges" :key="index">
                <img class="community-education-panel__partner-college-logo" referrerpolicy="no-referrer" :src="item.logo" />
                <span class="community-education-panel__partner-college-name" v-html="item.name"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="community-foundation__belief flex-col">
          <span class="community-foundation__belief-label">我们相信</span>
          <span class="community-foundation__belief-copy">
            优质的教育资源，不应该被家境所决定；
            <br />
            明确的职业方向，不应该被信息差所阻断。
          </span>
        </div>
        <div class="community-foundation__pursuit flex-col">
          <span class="community-foundation__pursuit-label">我们追求</span>
          <span class="community-foundation__pursuit-copy">
            借助商业的力量，做可持续的公益
            <br />
            让企业标准与学生成长双向奔赴，
            <br />
            让教育资源真正公平地流向每一个需要的人。
          </span>
        </div>
      </div>
      <div class="community-future flex-col">
        <div class="community-future__heading flex-row justify-between">
          <div class="community-future__heading-accent-start flex-col"></div>
          <span class="community-future__heading-label">携手聚星，共创未来</span>
          <div class="community-future__heading-accent-end flex-col"></div>
        </div>
        <span class="community-future__subtitle">汇聚四方力量，共筑人才生态，让每一方都能收获成长</span>
        <div class="community-audience-list flex-col">
          <div
            class="community-audience-card flex-col"
            :style="{ background: item.backgroundImage }"
            v-for="(item, index) in communityAudiences"
            :key="index"
          >
            <div class="community-audience-card__heading flex-row justify-between">
              <img class="community-audience-card__icon" referrerpolicy="no-referrer" :src="item.icon" />
              <div class="community-audience-card__subject">
                <span class="community-audience-card__prefix" v-html="item.headingPrefix"></span>
                <span class="community-audience-card__entity" :style="{ color: item.nameColor }" v-html="item.name"></span>
              </div>
            </div>
            <span class="community-audience-card__description" v-html="item.description"></span>
          </div>
        </div>
      </div>
      <div class="community-page__closing-section flex-col justify-between">
        <div class="community-contact flex-col">
          <div class="community-contact__heading flex-row"><span class="community-contact__heading-label">期待你的加入！</span></div>
          <div class="community-contact-card flex-row">
            <img
              class="community-contact-card__wechat-qr"
              referrerpolicy="no-referrer"
              src="@/assets/pages/contact/images/liu-teacher-wechat-qr.png"
              alt="刘老师微信二维码"
            />
            <div class="community-contact-card__advisor-details">
              <span class="community-contact-card__advisor-name">
                刘老师
                <br />
              </span>
              <span class="community-contact-card__phone-label">手机号：</span>
              <span class="community-contact-card__phone-number">
                18640109087
                <br />
              </span>
              <span class="community-contact-card__schedule-label">工作日：</span>
              <span class="community-contact-card__schedule">9:00～18:00</span>
            </div>
          </div>
        </div>
      </div>
      <app-footer />
      <app-floating-actions ref="floatingActions" />
    </div>
  </div>
</template>
<script>
import AppFloatingActions from '@/components/actions/AppFloatingActions.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import AppHeader from '@/components/navigation/AppHeader.vue'

export default {
  name: 'CommunityView',
  components: { AppFloatingActions, AppFooter, AppHeader },
  data() {
    return {
      stakeholderCards: [
        {
          cardBackground: `url(${require('@/assets/pages/community/images/remote/61550bbcf6abe311574730b9c17e29cb.png')}) 100% no-repeat`,
          icon: require('@/assets/pages/community/images/remote/6f115bf4b3373565ad47d25642fce05b.png'),
          title: '企业',
          footerDecoration: require('@/assets/pages/community/images/remote/076c170fa8bb374b2ae9f921b2705785.png'),
          partnerBenefits: {
            icon: require('@/assets/pages/community/images/remote/f0935aae7a8be5d341439a17725dc515.png'),
            description: '参与人才标准制定，精准选拔<br/>提前接触优质人才，降低培养成本<br/>承担社会责任，塑造雇主品牌',
            decoration: require('@/assets/pages/community/images/remote/2c4e2fa4453d55bffdcc65aa571bf798.png')
          }
        },
        {
          cardBackground: `url(${require('@/assets/pages/community/images/remote/1b493779acab7b6c41d901c7fdd46f69.png')}) 100% no-repeat`,
          icon: require('@/assets/pages/community/images/remote/2b01bd71630a153a5f5888cbd344f8e1.png'),
          title: '学生',
          footerDecoration: require('@/assets/pages/community/images/remote/f1211eee503a6ac9f6713ba04a6e7f23.png'),
          partnerBenefits: {
            icon: require('@/assets/pages/community/images/remote/7d0670acb835de9329a983cbaed96857.png'),
            description: '明确成长方向，少走弯路<br/>获得公益资源支持<br/>获得实习机会，积累实战经验',
            decoration: require('@/assets/pages/community/images/remote/f445408112264853d7a38af9e3e10f8d.png')
          }
        },
        {
          cardBackground: `url(${require('@/assets/pages/community/images/remote/5a37aab1188b6c11454b8a656aa9bc1f.png')}) 100% no-repeat`,
          icon: require('@/assets/pages/community/images/remote/c69230bcb33f020150e97c3c39b1ee1f.png'),
          title: '高校',
          footerDecoration: require('@/assets/pages/community/images/remote/0f7d31bef1b1aa1908f3d0c788d033ef.png'),
          showsUniversityBenefits: true
        }
      ],
      partnerColleges: [
        {
          logo: require('@/assets/pages/community/images/remote/8d888207a721614220f7c1575593edd7.png'),
          name: '辽宁科技<br/>大学'
        },
        {
          logo: require('@/assets/pages/community/images/remote/9badb67e921460378889d0398d1e39de.png'),
          name: '辽宁石油<br/>化工大学'
        },
        {
          logo: require('@/assets/pages/community/images/remote/9e86972ff7e24a653d979dba72c09ce2.png'),
          name: '大连舰艇<br/>学院'
        }
      ],
      communityAudiences: [
        {
          backgroundImage: `url(${require('@/assets/pages/community/images/remote/117c9bd982c9c2d2f8235fed182ffdee.png')}) 100% no-repeat`,
          icon: require('@/assets/pages/community/images/remote/d9c9a6948e70fb18e786804b1f7c8b7e.png'),
          headingPrefix: '我们面向：',
          name: '企业',
          nameColor: 'rgba(36, 105, 255, 1)',
          description: '参与制定人才标准，提前锁定优质人才，降低培养成<br/>本，加强校企深度合作，塑造雇主品牌。'
        },
        {
          backgroundImage: `url(${require('@/assets/pages/community/images/remote/f6820a15e3daec66bef79d6422f3efab.png')}) 100% no-repeat`,
          icon: require('@/assets/pages/community/images/remote/714e2aca5b6c053e1f795b2b19383c60.png'),
          headingPrefix: '我们面向：',
          name: '高校',
          nameColor: 'rgba(51, 187, 224, 1)',
          description: '共建场景化教学体系，提升学生实践能力与就业竞争<br/>力，探索产学研协同新模式。'
        },
        {
          backgroundImage: `url(${require('@/assets/pages/community/images/remote/e6aa11d4b5673d932c9bb2b7d0106879.png')}) 100% no-repeat`,
          icon: require('@/assets/pages/community/images/remote/a9d47c1e8b09db7df73f5251bba0449d.png'),
          headingPrefix: '我们面向：',
          name: '教培机构',
          nameColor: 'rgba(6, 194, 125, 1)',
          description: '加入聚星计划，共享公益教育资源，共同扩大教育影<br/>响力，让更多大学生受益。'
        },
        {
          backgroundImage: `url(${require('@/assets/pages/community/images/remote/f5e4b155465c186c1691cbfa6dde0077.png')}) 100% no-repeat`,
          icon: require('@/assets/pages/community/images/remote/33ade9de41ef99ae5cf031239bc355dd.png'),
          headingPrefix: '我们面向：',
          name: '大学生',
          nameColor: 'rgba(11, 133, 237, 1)',
          description: '优先加入社区，成为本校社团活动负责人，获得企业导<br/>师指导，拓展优质人脉，提前锁定成长机会。'
        }
      ]
    };
  },
  methods: {
    openContact() {
      if (this.$refs.floatingActions) {
        this.$refs.floatingActions.openContact()
      }
    }
  }
};
</script>
<style scoped lang="css" src="@/assets/pages/community/styles/index.response.css" />
